<template>
  <div
    v-if="pageShow && iscurrentPage"
    :class="['zeus-content-page', isFlow ? 'zeus-content-page-static' : '']"
    :style="getPageStyles()"
  >
    <template v-for="(component, index) in data.components">
      <component-group
        v-if="component.type == 'group'"
        :key="index"
        :data="component.children"
        :page="data"
        :site-data="siteData"
        :is-fixed-parent="isFixed && !isFixedParent"
        @hook:beforeDestroy="beforeDestroy"
      />
      <zeus-component
        v-else
        :key="index+1"
        :data="component"
        :page="data"
        :site-data="siteData"
        :is-fixed-parent="isFixed && !isFixedParent"
        @hook:beforeDestroy="beforeDestroy"
      />
    </template>
  </div>
</template>

  <script>
  import { renderBg } from '@/utils/tools'
  import ComponentGroup from './componentGroup'
  import { BsGetEnv } from 'dida-web-common'
  // import ComponentGroup from './componentGroup'
  import ZeusComponent from './component'
  export default {
      'props': {
          'data': {
              'type': Object,
              'default': () => ({})
          },
          'siteData': {
              'type': Object,
              'default': () => ({})
          },
          'mask': Boolean
      },
      'inject': ['globalConfig'],
      data() {
          return {
            'fixedData': {
                'position': 'absolute',
                'left': 0,
                'top': 0,
                'width': '100%',
                // 'height': '100%',
                'zIndex': 3000,
                'pointerEvents': 'none'
            },
            'pageShow': true,
            'origin': BsGetEnv.isEnvOnline ? 'https://web.didachuxing.com' : (BsGetEnv.isEnvECS ? 'https://web-simu.didachuxing.com' : 'https://web-test.didachuxing.com')

          }
      },
      'computed': {
          layoutType() {
              // this.pageShow = this.data?.options?.basic?.showPage
              return this.data?.options?.basic?.layoutType
          },
          style() {
              return this.data?.options?.style
          },
          iscurrentPage() {
            const rt = this.$root.currentRouter || 'default'

            if (rt !== 'default') {
                this.$root.closeLoading = true
            }

            return this.$root.pageRouter[rt]?.indexOf(this.data?.id) > -1
          },
          isFixed() {
              return this.layoutType === 'fixed'
          },
          isFlow() {
              return this.layoutType === 'static'
          },
          isMobile() {
              return window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
          },
          isFixedParent() {
            // if (window.ENV === 'development') return false // 不需要fixed
            const { color, image } = this.style.background
            // if (this.isPoster) return true // fixed
            if (image) return true
            if (!color || (color && color === 'transparent') || color.split(',').pop() === '0)') return false // 不需要fixed
            return true
        }

      },
      watch: {
          data: {
              handler(newdata) {
                  this.pageShow = newdata?.options?.basic?.showPage
              },
              immediate: true,
              deep: true
          },
          '$root.currentRouter': {
            handler() {
                // console.log(444, this.data.id)
                  this.pageShow = this.data?.options?.basic?.showPage
              }
          }
      },
      'methods': {
        beforeDestroy() {
            if (this.isFixedParent) {
                // document.querySelector('body').setAttribute('style', 'overflow: auto;')
            }
        },
          initEvents() {
              const action = this.data?.options?.action
              if (!action || !action.length) {
                  return
              }
              const handler = ({ handler, params = {}, 'options': { data } = { 'data': '' }}, { ctx }) => {
                const router = this.data?.options?.basic.pageRouter
                  switch (handler) {
                      case '$h_hide':
                          this.pageShow = false
                          break
                      case '$h_show':
                            if (this.$root.currentRouter !== (router || 'default')) {
                                this.$root.currentRouter = router || 'default'
                                this.$track.addStat(this.$root.productName + '_' + router)
                                window.history.pushState({ name: router }, null, `${this.origin}/${this.$root.productName}/${router}${location.search}${location.hash}`)
                                this.pageShow = true
                                scrollTo(0, 0)
                            } else {
                                this.pageShow = true
                            }
                          break
                  }
              }
              action.forEach((action) => {
                  action.subscribe && action.subscribe.forEach((subscribe) => {
                      this.$bus.$on(subscribe, (triggerParams) => {
                          handler(action, triggerParams)
                      })
                  })
              })
          },
          getPageStyles() {
              const fixedConfig = this.isFixed ? this.fixedData : {}
              const editAndFlowConfig = (window.$isEditing && this.isFlow) ? { 'minHeight': this.style.height + this.globalConfig.unit } : {}
              if (this.isFixedParent && fixedConfig.position) {
                fixedConfig.position = 'fixed'
                fixedConfig.pointerEvents = 'auto'
                // document.querySelector('body').setAttribute('style', 'overflow: hidden;')
              }
              let height = ''
              if (this.isFixed) {
                  height = window.$isEditing ? this.style.height + this.globalConfig.unit : '100vh'
              } else {
                  height = this.isFlow ? 'auto' : this.handlerUnit(this.style.height, this.style.fs)
              }
              return {
                  height,
                  'overflow': (window.$isEditing || this.isFixed) ? 'visible' : 'hidden',
                  // 'opacity': this.mask ? 0.3 : 1,
                  ...renderBg(this.style.background, this.$root.isSuWebp),
                  ...fixedConfig,
                  ...editAndFlowConfig
              }
          },
          handlerUnit(v, fs = false) {
              if (fs) {
                  return window.$isEditing ? '667px' : '100vh'
              }
              return isNaN(Number(v)) ? v : (v + this.globalConfig.unit)
          },
          handlerFixedScroll() {
              if (this.isFixed && !this.isMobile) {
                  this.fixedData.position = 'absolute'
                  window.addEventListener('scroll', () => {
                      this.fixedData.top = `${document.documentElement.scrollTop || document.body.scrollTop}px`
                  })
              }
          }
      },
      mounted() {
          this.initEvents()
          this.pageShow = this.data?.options?.basic?.showPage
      },
      created() {
          this.handlerFixedScroll()
      },
      'components': { ComponentGroup, ZeusComponent }
  }
  </script>

